module.exports = __webpack_public_path__ + "static/logo-coca-0d50dc47af085b736fb6ebe59c71092c.svg";